/*
 * Isolated pre-order dates. Own GraphQL + sibling JSON.
 * Never writes VariantsPage or [data-dd-variant-data].
 * Fail-open: a 500 here must not empty restock SKUs.
 */
(function () {
  'use strict';

  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var CACHE_PREFIX = 'dd_po_v1_';
  var CACHE_TTL = 300000;
  var INPUT_NAME = 'properties[_preorder_promise]';
  var DEFAULT_AFTER_SUNDAY = 10;

  function bufferDays() {
    var n = window.__ddPreorderBufferDays;
    if (n == null && window.__ddVariantLoaderConfig) {
      n = window.__ddVariantLoaderConfig.preorderBufferDays;
    }
    n = parseInt(n, 10);
    if (isNaN(n) || n < 0) n = DEFAULT_AFTER_SUNDAY;
    return n;
  }

  function toIsoLocal(dt) {
    var y = dt.getFullYear();
    var m = String(dt.getMonth() + 1);
    if (m.length < 2) m = '0' + m;
    var d = String(dt.getDate());
    if (d.length < 2) d = '0' + d;
    return y + '-' + m + '-' + d;
  }

  /* Sunday of the PO week, then +N. Same snap as dd-restock-label.js. */
  function customerIso(raw) {
    var date = isoFrom(raw);
    if (!isActive(date)) return null;
    var p = date.split('-');
    var y = parseInt(p[0], 10);
    var mo = parseInt(p[1], 10) - 1;
    var d = parseInt(p[2], 10);
    var po = new Date(y, mo, d);
    if (isNaN(po.getTime())) return null;
    var day = po.getDay();
    var mondayOffset = day === 0 ? -6 : 1 - day;
    var sunday = new Date(y, mo, d + mondayOffset + 6);
    var onSite = new Date(
      sunday.getFullYear(),
      sunday.getMonth(),
      sunday.getDate() + bufferDays()
    );
    return toIsoLocal(onSite);
  }

  function todayIso() {
    var n = new Date();
    var m = String(n.getMonth() + 1);
    if (m.length < 2) m = '0' + m;
    var d = String(n.getDate());
    if (d.length < 2) d = '0' + d;
    return n.getFullYear() + '-' + m + '-' + d;
  }

  function isoFrom(raw) {
    if (!raw || typeof raw !== 'string') return null;
    var m = /^(\d{4}-\d{2}-\d{2})/.exec(raw.trim());
    return m ? m[1] : null;
  }

  function isActive(iso) {
    var date = isoFrom(iso);
    return !!(date && date >= todayIso());
  }

  function prettyDay(iso) {
    var date = isoFrom(iso);
    if (!date) return '';
    var p = date.split('-');
    var month = MONTHS[parseInt(p[1], 10) - 1] || '';
    var day = String(parseInt(p[2], 10));
    return month + ' ' + day;
  }

  function numericDay(iso) {
    var date = isoFrom(iso);
    if (!date) return '';
    var p = date.split('-');
    return String(parseInt(p[1], 10)) + '/' + String(parseInt(p[2], 10));
  }

  function byline(iso) {
    var day = prettyDay(iso);
    return day ? 'Ships by ' + day : '';
  }

  function shipNote(iso) {
    var day = numericDay(iso);
    return day
      ? 'Estimated to ship ' + day + '. Subject to delays.'
      : 'Estimated to ship. Subject to delays.';
  }

  function label(iso) {
    var day = prettyDay(iso);
    return day ? 'Pre-order \u00b7 Ships by ' + day : 'Pre-order';
  }

  function atcAddText(host) {
    var root = host && host.closest ? host.closest('[data-add-text]') : null;
    var t = root && root.getAttribute('data-add-text');
    if (t && String(t).trim() && !/^pre-order/i.test(t) && !/^incoming/i.test(t)) {
      return String(t).trim();
    }
    return 'Add to cart';
  }

  function atcFace(iso, addText) {
    var day = numericDay(iso);
    var add = addText && String(addText).trim() ? String(addText).trim() : '';
    var custom =
      add &&
      !/^add to cart$/i.test(add) &&
      !/^pre-order/i.test(add) &&
      !/^incoming/i.test(add);
    if (custom) return day ? add + ' \u00b7 Est. ship ' + day : add;
    return 'Pre-order';
  }

  function incomingFace(iso) {
    var day = numericDay(iso);
    return day ? 'PRE-ORDER ' + day : 'PRE-ORDER';
  }

  function paintAtcLabel(host, iso) {
    if (!host) return;
    var text = atcFace(iso, atcAddText(host));
    var current = (host.textContent || '').replace(/\s+/g, ' ').trim();
    if (current === text && !host.querySelector('.dd-atc-preorder-title')) return;
    host.classList.remove('dd-atc-button__text--marquee', 'dd-sticky-footer__atc-label--marquee');
    host.style.removeProperty('--dd-atc-marquee-duration');
    host.style.removeProperty('--dd-sf-atc-marquee-duration');
    host.textContent = text;
  }

  function getCache(key) {
    try {
      var raw = sessionStorage.getItem(key);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || parsed.expires < Date.now() || !parsed.map) return null;
      return parsed.map;
    } catch (e) {
      return null;
    }
  }

  function setCache(key, map) {
    try {
      sessionStorage.setItem(key, JSON.stringify({ expires: Date.now() + CACHE_TTL, map: map }));
    } catch (e) { /* */ }
  }

  var api = {
    map: {},

    get: function (id) {
      if (id == null) return null;
      return customerIso(this.map[String(id)]);
    },

    label: label,
    byline: byline,
    shipNote: shipNote,
    prettyDay: prettyDay,
    numericDay: numericDay,
    atcFace: atcFace,
    incomingFace: incomingFace,
    paintAtcLabel: paintAtcLabel,

    merge: function (obj) {
      if (!obj || typeof obj !== 'object') return;
      var keys = Object.keys(obj);
      for (var i = 0; i < keys.length; i++) {
        var iso = isoFrom(obj[keys[i]]);
        if (iso) this.map[String(keys[i])] = iso;
      }
    },

    syncForm: function (variantId) {
      var form = document.querySelector('form[action*="/cart/add"]');
      if (!form) return;
      var iso = this.get(variantId);
      var input = form.querySelector('input[name="' + INPUT_NAME + '"]');
      if (!iso) {
        if (input) input.parentNode.removeChild(input);
        return;
      }
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = INPUT_NAME;
        form.appendChild(input);
      }
      input.value = iso;
    },

    applySurfaces: function () {
      var ss = document.querySelector('dd-swatch-selector');
      var variant = ss && typeof ss.getCurrentVariant === 'function' ? ss.getCurrentVariant() : null;
      var iso = variant ? this.get(variant.id) : null;

      this.syncForm(variant && variant.id);

      if (typeof window.__ddSyncTrustShip === 'function') {
        try { window.__ddSyncTrustShip(); } catch (e) { /* */ }
      }

      var submit = document.querySelector('.product-form__submit');
      if (submit) submit.classList.toggle('is--preorder-label', !!iso);

      if (ss && typeof ss.applyPreorderBadges === 'function') {
        try { ss.applyPreorderBadges(); } catch (e) { /* */ }
      }

      var sticky = document.querySelector('dd-sticky-footer');
      if (sticky && typeof sticky.updateShippingAndCustom === 'function' && variant) {
        try { sticky.updateShippingAndCustom(variant); } catch (e) { /* */ }
      }
    },

    fetch: function (productHandle) {
      var self = this;
      if (!productHandle) return Promise.resolve(this.map);
      var cfg = window.__ddVariantLoaderConfig;
      if (!cfg || !cfg.token) return Promise.resolve(this.map);

      var cacheKey = CACHE_PREFIX + productHandle;
      var cached = getCache(cacheKey);
      if (cached && Object.keys(cached).length) {
        this.merge(cached);
        return Promise.resolve(this.map);
      }

      var query = [
        'query PreorderPage($handle: String!, $first: Int!, $after: String) {',
        '  product(handle: $handle) {',
        '    variants(first: $first, after: $after) {',
        '      pageInfo { hasNextPage endCursor }',
        '      nodes {',
        '        id',
        '        metafield(namespace: "moqbird", key: "preorder_promise") { value }',
        '      }',
        '    }',
        '  }',
        '}'
      ].join('\n');

      var collected = {};

      function sfFetch(after) {
        return fetch('/api/' + (cfg.version || '2026-04') + '/graphql.json', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': cfg.token
          },
          body: JSON.stringify({
            query: query,
            variables: { handle: productHandle, first: 250, after: after || null }
          })
        }).then(function (r) {
          if (!r.ok) throw new Error('preorder fetch ' + r.status);
          return r.json();
        }).then(function (data) {
          if (data && data.errors && data.errors.length) throw new Error('preorder graphql');
          var product = data && data.data && data.data.product;
          if (!product) return collected;
          var nodes = product.variants && product.variants.nodes || [];
          var pageInfo = product.variants && product.variants.pageInfo;
          for (var i = 0; i < nodes.length; i++) {
            var n = nodes[i];
            var gid = String(n.id || '');
            var numericId = gid.indexOf('/') !== -1 ? gid.split('/').pop() : gid;
            var raw = n.metafield && n.metafield.value;
            var iso = isoFrom(raw);
            if (iso) collected[numericId] = iso;
          }
          if (pageInfo && pageInfo.hasNextPage && pageInfo.endCursor) {
            return sfFetch(pageInfo.endCursor);
          }
          return collected;
        });
      }

      return sfFetch(null).then(function (map) {
        setCache(cacheKey, map);
        self.merge(map);
        return self.map;
      }).catch(function (err) {
        console.warn('[dd-preorder]', err && err.message ? err.message : err);
        return self.map;
      });
    }
  };

  window.ddPreorder = api;
  window._ddPreorderMap = api.map;

  function seedSibling() {
    var el = document.querySelector('[data-dd-preorder-data]');
    if (!el) return;
    try {
      var parsed = JSON.parse(el.textContent);
      api.merge(parsed);
    } catch (e) { /* sibling must never break restock */ }
  }

  function boot() {
    seedSibling();
    var handleEl = document.querySelector('[data-product-handle], dd-swatch-selector[data-product-handle]');
    var handle = handleEl && (handleEl.getAttribute('data-product-handle') || handleEl.dataset.productHandle);
    if (!handle) {
      var path = window.location.pathname || '';
      var m = /\/products\/([^/?#]+)/.exec(path);
      handle = m ? decodeURIComponent(m[1]) : '';
    }
    var ready = handle ? api.fetch(handle) : Promise.resolve(api.map);
    ready.then(function () {
      api.applySurfaces();
      try {
        document.dispatchEvent(new CustomEvent('dd:preorder-map-ready'));
      } catch (e) { /* */ }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('variant:change', function () {
    api.applySurfaces();
  });
  document.addEventListener('dd:variants-full', function () {
    api.applySurfaces();
  });
})();
